import React, { Component, PropTypes } from 'react'
import IconBackarrow from 'icons/IconBackarrow'
import styles from './BackToAdminCentre.scss'
import { Link } from 'react-router-dom'

const BackToAdminCentre = ({ displayText, isAdmin }) => {
  if (isAdmin && (window.location.href.indexOf('admin/') > -1)) {
    const linkTo = (window.location.href.indexOf('admin/detailedreport') > -1) ? '/admin/reports' : '/admin/admincentre'
    return (
      <div className={styles.wrapper} >
        <Link to={linkTo}>
          <IconBackarrow className={styles.BackImage} />
        </Link>
        <span className={styles.Heading}>{displayText}</span>
      </div >
    )
  }
  return (<div />)
}

export default BackToAdminCentre



// WEBPACK FOOTER //
// ./src/components/BackToAdminCentre/BackToAdminCentre.js